module.exports = require("live/components/header/ui/main/main");